"use strict";

($dt => {

	const { STRIPE } = $dt.TopicGrid.Constants;
	const { on_nothing } = $dt.TopicGrid.Functions;

	/**
	 * Deposit Payment Type Selection
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 * @param { () => {} } on_pay_details_changed
	 */
	$dt.TopicGrid.ScreenFunctions.o2_i0 = (block, inner_screen, controller, on_pay_details_changed) => {
		let paytype_selected = null, amount_selected = null;
		const { inner_elem } = inner_screen;
		const [
			button_next_elem,
			button_prev_elem,
			pay_option_elems,
			button_next_text_elem,
			amount_selection_elem,
			amount_option_elems,
		] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelectorAll('.deposit-type-selection .type-buttons a'),
			inner_elem.querySelector('.button-next .link-text'),
			inner_elem.querySelector('.deposit-type-selection .amount-buttons'),
			inner_elem.querySelectorAll('.deposit-type-selection .amount-buttons a'),
		];

		const reset_amount_selected = () => {
			amount_selected = null;
			amount_option_elems.forEach(elem => elem.classList.remove('active'));
		};

		const reset_paytype_selected = () => {
			paytype_selected = null;
			button_next_elem.setAttribute('disabled', '');
			button_next_text_elem.innerHTML = $dt.topic_button_texts.next;
			pay_option_elems.forEach(elem => elem.classList.remove('active'));
			amount_selection_elem.classList.remove('buttons-are-active');
			reset_amount_selected();
		};

		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.outer = 0;
			current_screen.inner = 6;
			controller.SetScreenUI(block);
		});

		pay_option_elems.forEach(pay_button_elem => {
			pay_button_elem.addEventListener('click', () => {
				if (!paytype_selected || paytype_selected === 'po') {
					// We are switching over to CC for first time or after PO, must reset next button
					reset_amount_selected();
					button_next_elem.setAttribute('disabled', '');
				}
				paytype_selected = pay_button_elem.getAttribute('data-type');
				pay_option_elems.forEach(elem => elem.classList.remove('active'));
				pay_button_elem.classList.add('active');

				switch (paytype_selected) {
					case 'cc':
						button_next_text_elem.innerHTML = $dt.topic_button_texts.pay_now;
						amount_selection_elem.classList.add('buttons-are-active');
						on_pay_details_changed(paytype_selected, amount_selected);
						break;
					case 'po':
						button_next_text_elem.innerHTML = $dt.topic_button_texts.book_now;
						button_next_elem.removeAttribute('disabled');
						amount_selection_elem.classList.remove('buttons-are-active');
						reset_amount_selected();
						on_pay_details_changed(paytype_selected, amount_selected);
						break;
				}
			});
		});

		amount_option_elems.forEach(button_elem => {
			button_elem.addEventListener('click', () => {
				amount_selected = button_elem.getAttribute('data-amount');
				amount_option_elems.forEach(elem => elem.classList.remove('active'));
				button_elem.classList.add('active');
				button_next_elem.removeAttribute('disabled');
				on_pay_details_changed(paytype_selected, amount_selected);

				/*switch (amount_selected) {
					case 'full':
						button_next_text_elem.innerHTML = $dt.topic_button_texts.pay_now;
						break;
					case 'deposit':
						button_next_text_elem.innerHTML = $dt.topic_button_texts.book_now;
						break;
				}*/
			});
		});

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {
				const form_submit = () => {
					if (paytype_selected !== null) {
						const { scheduling_info, d3df_page_options, current_screen, current_topic } = block;

						scheduling_info.paytype_selected = paytype_selected;
						scheduling_info.amount_to_pay = amount_selected;

						// Generate Payment Intent and move on to purchase
						controller.StartWaiting(block);
						controller.ResetFormValidation(form);

						// Submit final form processing
						form.currentContainer = inner_elem; // setting this for the error summary for API issues
						const data = {
							//paytype_selected: paytype_selected // shouldnt be needed, added by SetSchedulingFormData
						};

						// Known scheduling info for progressive form saving
						controller.SetSchedulingFormData(block, data);

						// Contact Info if Anonymous
						controller.SetContactInfoFormData(block, data);

						const on_complete = () => {
							controller.EndWaiting(block);
						};

						const on_validation_error = errors => {
							controller.FormValidationFailed(form, errors);
						};

						const on_success = resp => {
							if (paytype_selected === 'po') {
								// Finalize
								scheduling_info.order_id = resp.entity.egalaxy_order_id.value;

								// Reset answers to questions
								scheduling_info.class_info_questions = [];

								// Transition Screen							
								current_screen.outer = 0;
								current_screen.inner = 7;
								controller.SetScreenUI(block);
							} else if (paytype_selected === 'cc') {
								// Get PI client secret
								const stripe = $dt.Stripe;
								const cs = resp.dev_attachment.client_s;

								// Create payment elements
								if (stripe.enabled) {
									stripe.createNewElements(current_topic.deposit_location, cs);
									const payment_elem = stripe.createPaymentElement();
									if (STRIPE.address) {
										stripe.createAddressElement(block.contact_info);
									}
									if (payment_elem) {
										block.stripe_elements = stripe.elements;
										// Transition Screen							
										current_screen.outer = 2;
										current_screen.inner = 1;
										controller.SetScreenUI(block);
									}
								} else {
									console.warn('Stripe API not available', stripe);
								}
							}
						};

						// Update page options
						if (paytype_selected === 'po') {
							d3df_page_options.pageIndex = false;
						} else {
							d3df_page_options.pageIndex = 2;
						}
						d3df_page_options.onSuccess = on_success;

						// Send to server for finalization
						form.submit(data, on_success, on_validation_error, on_nothing, on_complete, d3df_page_options);
					}
				};

				button_next_elem.addEventListener('click', $dt.Util.debounce(form_submit, $df.debounceThreshold));
			});
		});

		// Field prepopulators
		inner_screen.Show = () => {
			reset_paytype_selected();
			on_pay_details_changed(paytype_selected, amount_selected);
		};
	};

})(window.d3_wp_themejs);
